
function FacebookSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.8962 0H1.10375C0.49375 0 0 0.49375 0 1.10375V18.8962C0 19.5063 0.49375 20 1.10375 20H10.6825V12.255H8.07625V9.23625H10.6825V7.01C10.6825 4.4275 12.26 3.02125 14.565 3.02125C15.6688 3.02125 16.6175 3.1025 16.8938 3.14V5.83875L15.2963 5.84C14.0425 5.84 13.8 6.435 13.8 7.31V9.23625H16.7887L16.4 12.255H13.8V20H18.8962C19.5063 20 20 19.5063 20 18.8962V1.10375C20 0.49375 19.5063 0 18.8962 0Z" fill="#A0A0A0"/>
    </svg>
  )
}

export { FacebookSVG }